import _ from 'lodash';
import { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { DataManagementContext } from '../../components/viewers/DataManagementViewer';
import { gEnums } from '../../enums/globalEnums';
import { _animateTypes } from '../../motions/AnimateComponent';
import MotionComponent from '../../motions/MotionComponent';
import { dataHandlers, dataInitialState, dataReducer } from '../reducers/DataReducer';
import { PageDataContext } from './PageDataContext';
import { ParentContext } from './ParentContext';
import { useItemData } from './useHelpers/useItemData';

/** gets the data for the uiItem.
 @returns viewListData,  
 @returns confirmation,  
*/
export const DataContext = createContext();

const DataProvider = (props) => {

  const {
    diKey,
    forAppViewer,
    isSettingData,
    itemListData,
    uivi,
    updateProps,
  } = props

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}

  const {
    currentSettings_state,
    page_state,
    paps_state,
    storage_state,
    transition_state,
  } = states

  const { aps_global, aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});

  // papsContext  
  const { view, viewKey, showStatus } = paps_state ?? {}

  // transitionContext  
  const { transitions } = transition_state ?? {}
  const transition = transitions ? transitions[_animateTypes.data] : null
  const { showTransition } = transition ?? {}

  // storageContext 
  const { pageItemImages } = storage_state ?? {}
  const pageImages = pageItemImages && pageItemImages[view] ? pageItemImages[view] : {}

  // pageContext  
  const { dataOptions } = aps_global ?? {}
  const { onDemand, } = dataOptions ?? {}
  const { viewItems: viewItems_page } = aps_page ?? {}

  // pageDataContext
  const pageDataContext = useContext(PageDataContext);
  const { pageData_handlers } = pageDataContext ?? {}

  // dataManagementContext
  const dataManagementContext = useContext(DataManagementContext)
  const { dataManagement_state } = dataManagementContext ?? {}
  const { viewItem_preview } = dataManagement_state ?? {}

  // test for other settings
  let isCombinedData = false
  let cbnVis = {}
  let returnFsr;

  let viewItem_page = viewItems_page?.[uivi] || {}

  if (viewItem_preview) {
    viewItem_page = viewItem_preview
    returnFsr = true
  }

  if (forAppViewer) {
    viewItem_page = aps_viewItems?.[uivi] || {}
  }

  const { combinedGroups, dataSource } = viewItem_page ?? {}

  const { dataSourceType: dataSourceType_page, dataCollectionName } = dataSource ?? {}

  if (combinedGroups) {
    cbnVis[viewItem_page.key] = viewItem_page
    Object.keys(combinedGroups).forEach(key => {
      cbnVis[key] = combinedGroups[key]
    })
    isCombinedData = true
  }

  let viewItem_g;
  if (aps_viewItems && aps_viewItems[uivi]) { viewItem_g = aps_viewItems[uivi] }
  const { dataConnection } = viewItem_g ?? {}
  const { altCollectionName } = dataConnection ?? {}


  let dataCollection = dataCollectionName
  let trueViewKey = viewKey

  if (altCollectionName) {
    dataCollection = altCollectionName
    trueViewKey = null
  }

  let delayData = onDemand ? true : false

  // IMPORTANT: Data - Get the data for the viewItem
  const dataInit_state = {
    diKey,
    isCombinedData,
    isSettingData,
    itemListData,
    pageImages,
    uivi,
    updateProps,
    viewItem: viewItem_page,
  }

  const [data_state, data_dispatch] = useReducer(dataReducer, dataInitialState(dataInit_state));

  const data_handlers = useMemo(
    () => dataHandlers(data_dispatch),
    [data_dispatch]
  );

  const { itemDataInfo } = useItemData({ dataInit_state })

  // console.log('dataInit_state', dataInit_state)

  useEffect(() => {
    if (itemDataInfo) {
      data_handlers.handleLoad_itemData(itemDataInfo)
      pageData_handlers && pageData_handlers.handleItemDataCounts(itemDataInfo.itemDataName, itemDataInfo.itemDataName, _.size(itemDataInfo?.itemData))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemDataInfo]);

  const { alphaValue } = data_state ?? {}

  if (onDemand && alphaValue) { delayData = false }

  let viewListData = data_state?.[dataCollection] || null

  if (showStatus && viewListData) { console.log('data_state ready', dataCollection, data_state) }

  const shouldProvide = (viewItem_page && viewListData) || itemListData || (forAppViewer && viewListData) || dataSourceType_page === gEnums.dataSourceTypes.component

  const content = () => {
    if (!shouldProvide) return <div />

    return (
      <DataContext.Provider value={{ data_state, data_handlers }}>
        {props.children}
      </DataContext.Provider>
    )
  }

  if (showTransition) {
    return <MotionComponent transition={transition}>
      {content()}
    </MotionComponent>
  } else {
    return content()
  }
}

export default DataProvider
